/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { InteraccionesFarmacosDto } from '../../models/interacciones-farmacos-dto';

export interface DoctorFarmacosControllerGetInteraccionesFarmacos$Params {
}

export function doctorFarmacosControllerGetInteraccionesFarmacos(http: HttpClient, rootUrl: string, params?: DoctorFarmacosControllerGetInteraccionesFarmacos$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<InteraccionesFarmacosDto>>> {
  const rb = new RequestBuilder(rootUrl, doctorFarmacosControllerGetInteraccionesFarmacos.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<InteraccionesFarmacosDto>>;
    })
  );
}

doctorFarmacosControllerGetInteraccionesFarmacos.PATH = '/api/farmacos/interacciones';
